export const PRESET_OPTIONS_MAP = {
	TODAY: "TODAY",
	LAST_7_DAYS: "LAST_7_DAYS",
	NEXT_7_DAYS: "NEXT_7_DAYS",
	THIS_MONTH: "THIS_MONTH",
	LAST_MONTH: "LAST_MONTH",
	NEXT_MONTH: "NEXT_MONTH",
} as const;

export type PresetOptionsType = keyof typeof PRESET_OPTIONS_MAP;
